module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product productSuitcase"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "overlayImage"
  }), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.dataLuggage.attributes.luggage_type.attributes.name) + " - " + _vm._s(_vm.dataLuggage.numeration))])])]), _vm._v(" "), _c('div', {
    staticClass: "imageContent"
  }, [_vm._m(0), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 1) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/mSQZTM9/maleta-De-Mano.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 2) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/CJhVtQ0/maleta.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 3) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/pZYJLpy/mochila.jpg",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataLuggage.attributes.luggage_type.attributes.key == 4) ? _c('img', {
    attrs: {
      "src": "https://i.ibb.co/K6T2hWp/box.png",
      "alt": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "price-after"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.dataLuggage.attributes.weight) + " kg")])]), _vm._v(" "), _c('h3', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.dataLuggage.attributes.description) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ctrls por clearfix"
  }, [_c('button', {
    staticClass: "btn btn-danger proDelete",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.quitLuggageItem
    }
  }, [_vm._v("Quitar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flag"
  }, [_c('p', {
    staticClass: "tag"
  }, [_vm._v("Alta")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9c842d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/items/card-add-luggage.vue
// module id = 1921
// module chunks = 1